import { gql } from "graphql-tag";

export const AUTH_USER_FIELDS_FRAGMENT = gql`
  fragment AuthUserFieldsFragment on User {
    id
    first_name
    last_name
    email
    role
    pharmacy_id
    created_at
    pharmacy {
      id
      name
      city
      phone_number
      is_active
    }
  }
`;

export const AUTH_USER_QUERY = gql`
  query GetAuthUser {
    authUser {
      id
      first_name
      last_name
      email
      email_verified_at
      role
      phone_number
      pharmacy_id
      locale
      pharmacy {
        id
        name
        city
        phone_number
        is_active
      }
    }
  }
`;

export const UPDATE_AUTH_USER_MUTATION = gql`
  mutation UpdateAuthUser($input: UpdateAuthUserInput!) {
    updateAuthUser(input: $input) {
      success
    }
  }
`;

export const UPDATE_AUTH_USER_PASSWORD_MUTATION = gql`
  mutation UpdateAuthUserPassword($input: UpdateAuthUserPasswordInput!) {
    updateAuthUserPassword(input: $input) {
      success
    }
  }
`;

export const CHANGE_EMAIL_MUTATION = gql`
  mutation ChangeEmail($input: ChangeEmailInput!) {
    changeEmail(input: $input) {
      status
      message
    }
  }
`;

export const RESEND_EMAIL_VERIFICATION_MUTATION = gql`
  mutation ResendEmailVerification($input: ResendEmailVerificationInput!) {
    resendEmailVerification(input: $input) {
      success
      message
    }
  }
`;

export const ME_QUERY = gql`
  query Me {
    me {
      id
      first_name
      last_name
      email
      avatar
    }
  }
`;
